import {type CSSProperties} from 'react';
import {useTranslation} from 'react-i18next';
import {cn, Skeleton} from '@chekinapp/ui';
import {getSideCopy} from './documentCopy';
import type {DocumentSide, DocumentVisual} from './types';
import {getFallbackAspectRatio, useDocumentVisualImage} from './useDocumentVisualImage';
import styles from './documentCatalog.module.css';

type Props = {
  visual: DocumentVisual;
  imageKey?: string;
  side?: DocumentSide;
  className?: string;
  style?: CSSProperties;
};

function DocumentPreview({visual, imageKey, side, className, style}: Props) {
  const {t} = useTranslation('identity-verification');
  const {src, hasFailed} = useDocumentVisualImage(imageKey ?? visual.image);

  if (hasFailed) return null;

  return (
    <div
      role="img"
      aria-label={t(getSideCopy(side ?? visual.side).alt)}
      className={cn('iv-document-preview relative w-full max-w-[320px]', className)}
      style={style}
    >
      {src ? (
        <img src={src} alt="" draggable={false} className={styles.image} />
      ) : (
        <Skeleton
          className="w-full rounded-[12px]"
          style={{aspectRatio: String(getFallbackAspectRatio(visual.kind))}}
        />
      )}
    </div>
  );
}

export {DocumentPreview};
